<template>
    <dropdown-menu top-bar>
        <template #button>
            <button class="menu-item item">
                <i class="i-ph-folder-star-fill block" title="Favoritter"/>
                <span class="item-text">Favoritter</span>
            </button>
        </template>
        <template #dropdown="{close}">
            <div class="flex flex-col pr-1">
                <button
                    v-for="(layout, index) in layouts"
                    :key="layout.name"
                    class="l2"
                    :title="`Favoritt ${index +1}`"
                    @click="handleLayoutClick(layout, close)"
                >
                    <i :class="layout.icon" class="block"/>
                    {{ layout.name }}
                </button>
            </div>
        </template>
    </dropdown-menu>
</template>

<script setup lang="ts">

import DropdownMenu from '@/components/DropdownMenu.vue'
import {hotkeySequence} from '@/hotkeys/useHotkeys'
import {Layout, useFavoriteLayouts} from '@/favourites/favourites.service'

const {layouts, activateLayout} = useFavoriteLayouts()

const handleLayoutClick = (layout: Layout, close: Function) => {
    activateLayout(layout)
    close()
}

layouts.forEach(layout => {
    hotkeySequence(['g', 'f', layout.layoutId], () => activateLayout(layout))
})

</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

.menu-item {
    @apply items-center mx-0.5 text-xs py-1;

    i {
        @apply text-lg mr-1;
    }
}

.item {
    @apply flex flex-col;
}

.l1, .l2 {
    @apply my-1 flex items-center hover:text-primary;

    i {
        @apply mr-1;
    }
}

.l2 {
    @apply ml-4;
}


.item-text {
    display: none;
    @media (min-width: 1250px) {
        display: block;
    }
}
</style>